import React from "react";
import { useWallet } from "../../contexts/WalletContext";
import { shorten, fmtEth, CHAIN } from "../../lib/format";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "../ui/dropdown-menu";

export default function WalletButton() {
  const { hasInjected, walletType, account, onBlokista, balance, connecting, connect, connectWalletConnect, disconnect, addOrSwitchChain } = useWallet();

  if (!account) {
    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button className="btn-amber py-2 px-4 text-[12px] whitespace-nowrap" disabled={connecting} data-testid="connect-wallet-btn">
            <i className="fa-solid fa-wallet mr-1.5" />
            {connecting ? "Connecting…" : "Connect Wallet"}
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          align="end"
          className="min-w-[220px]"
          style={{ background: "var(--bg-2)", border: "1px solid var(--border-2)", color: "var(--text)" }}
          data-testid="connect-wallet-menu"
        >
          <DropdownMenuLabel className="text-[11px]" style={{ color: "var(--muted)" }}>Choose a wallet</DropdownMenuLabel>
          <DropdownMenuSeparator style={{ background: "var(--border)" }} />
          <DropdownMenuItem
            onClick={connect}
            className="cursor-pointer text-[12.5px]"
            style={{ color: "var(--text)" }}
            data-testid="connect-injected-option"
          >
            <i className="fa-solid fa-plug mr-2" style={{ color: "var(--amber)" }} />
            {hasInjected ? "Browser Wallet (MetaMask)" : "Install MetaMask"}
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={connectWalletConnect}
            className="cursor-pointer text-[12.5px]"
            style={{ color: "var(--text)" }}
            data-testid="connect-walletconnect-option"
          >
            <i className="fa-solid fa-qrcode mr-2" style={{ color: "var(--amber)" }} />
            WalletConnect (QR / Mobile)
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    );
  }

  if (!onBlokista) {
    return (
      <button className="nav-link" style={{ borderColor: "var(--red)", color: "var(--red)" }} onClick={addOrSwitchChain} data-testid="switch-network-btn">
        <i className="fa-solid fa-triangle-exclamation mr-1.5" /> Switch to Blokista
      </button>
    );
  }

  return (
    <div className="flex items-center gap-2 px-2.5 py-1.5 rounded-full" style={{ background: "var(--bg-2)", border: "1px solid var(--border-2)" }} data-testid="wallet-connected">
      <span className="dot dot-green live-dot" />
      <span className="mono text-[11.5px]" style={{ color: "var(--text)" }} data-testid="wallet-balance">{fmtEth(balance, 3)} {CHAIN.symbol}</span>
      <span style={{ color: "var(--border-2)" }}>·</span>
      <span className="mono text-[11.5px]" style={{ color: "var(--amber)" }} data-testid="wallet-account" title={walletType === "walletconnect" ? "Connected via WalletConnect" : "Connected via browser wallet"}>
        {walletType === "walletconnect" && <i className="fa-solid fa-qrcode mr-1" />}{shorten(account, 5, 4)}
      </span>
      <button className="icon-btn" style={{ width: 24, height: 24 }} title="Disconnect" onClick={disconnect} data-testid="wallet-disconnect">
        <i className="fa-solid fa-right-from-bracket text-[11px]" />
      </button>
    </div>
  );
}
